import React from 'react';
import { FaHeart, FaRegHeart } from 'react-icons/fa6';
import useFavorites from '../../../configurations/useFavorites';

/**
 * Heart toggle button - kisi bhi doctor ko favorite me daalne/nikalne ke liye.
 * DoctorsCard ke andar daalo (card ko `relative` rakhna) aur `item` pass karo.
 *
 * Example:
 *   <div className="relative ...card...">
 *       <FavoriteButton item={item} className="absolute top-3 right-3 z-10" />
 *       ...baaki card...
 *   </div>
 */
export default function FavoriteButton({ item, size = 18, className = '' }) {
    const { isFavorite, toggleFavorite } = useFavorites();
    const active = isFavorite(item);

    const handleClick = (e) => {
        // agar card khud clickable/Link ke andar hai to navigate na ho
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(item);
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            aria-label={active ? 'Remove from favorites' : 'Add to favorites'}
            className={`
                grid place-items-center h-9 w-9 rounded-full shadow-md
                backdrop-blur-sm transition-all duration-300 active:scale-90
                ${active
                    ? 'bg-red-50 text-red-500'
                    : 'bg-white/90 text-gray-400 hover:text-red-500 hover:bg-white'}
                ${className}
            `}
        >
            {active
                ? <FaHeart size={size} className="animate-[pop_0.25s_ease-out]" />
                : <FaRegHeart size={size} />}
        </button>
    );
}